import { Stack } from "@mui/material";

const IconBackground = ({ children, sx = {} }) => {
  return (
    <Stack
      direction={"column"}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        background: "#F3F3F5",
        border: "4px solid #FAFAFA",
        width: 40,
        height: 40,
        borderRadius: "50%",
        padding: "0px",
        ...sx,
      }}
    >
      {children}
    </Stack>
  );
};
export const IconBackgroundDelete = ({ children }) => {
  return (
    <Stack
      direction={"column"}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        background: "#FEE4E2",
        border: "8px solid #FEF3F2",
        width: "fit-content",
        borderRadius: "50%",
        padding: "4px",
      }}
    >
      {children}
    </Stack>
  );
};
export const IconBackgroundSuccess = ({ children }) => {
  return (
    <Stack
      direction={"column"}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        background: "#D1FADF",
        border: "8px solid #ECFDF3",
        width: "fit-content",
        borderRadius: "50%",
        padding: "4px",
      }}
    >
      {children}
    </Stack>
  );
};
export const IconBackgroundInactive = ({ children }) => {
  return (
    <Stack
      direction={"column"}
      sx={(theme) => {
        const { backgroundBorder, iconBackground } =
          theme.palette.status.deactivated;
        return {
          alignItems: "center",
          justifyContent: "center",
          background: iconBackground,
          border: `8px solid ${backgroundBorder}`,
          // width: "fit-content",
          borderRadius: "50%",
          padding: "4px",
          height: 48,
          width: 48,
        };
      }}
    >
      {children}
    </Stack>
  );
};

export default IconBackground;
